
import { jsPDF } from "jspdf";
import { PdfSectionOptions } from "../types";

/**
 * Add strengths and improvements sections
 */
export const addStrengthsAndImprovements = (
  { doc, pageWidth, y, colors }: PdfSectionOptions, 
  strengths: string[], 
  improvements: string[]
): number => {
  // Key strengths section
  doc.setFontSize(14);
  doc.setTextColor(colors?.primaryPurple[0] || 103, colors?.primaryPurple[1] || 36, colors?.primaryPurple[2] || 125);
  doc.text("Key Strengths", 15, y);
  
  doc.setDrawColor(39, 174, 96); // Green for strengths
  doc.setLineWidth(0.8);
  doc.line(15, y + 5, 80, y + 5);
  
  doc.setTextColor(0, 0, 0);
  let newY = y + 15;
  if (strengths.length > 0) {
    strengths.forEach((strength, index) => {
      doc.setFontSize(11);
      const bulletPoint = `• `;
      const indentedText = `${strength}`;
      doc.text(bulletPoint, 15, newY);
      const strengthLines = doc.splitTextToSize(indentedText, pageWidth - 35);
      doc.text(strengthLines, 20, newY);
      newY += (strengthLines.length * 6) + 4; // Improved spacing
    });
  } else {
    doc.setFontSize(11);
    doc.text("No notable strengths identified.", 15, newY);
    newY += 10;
  }
  
  // Add some spacing between sections
  newY += 10;
  
  // Improvement areas
  doc.setFontSize(14);
  doc.setTextColor(colors?.primaryPurple[0] || 103, colors?.primaryPurple[1] || 36, colors?.primaryPurple[2] || 125);
  doc.text("Improvement Areas", 15, newY);
  
  doc.setDrawColor(231, 76, 60); // Red for improvements
  doc.line(15, newY + 5, 100, newY + 5);
  
  doc.setTextColor(0, 0, 0);
  newY += 15;
  if (improvements.length > 0) {
    improvements.forEach((improvement, index) => {
      doc.setFontSize(11);
      const bulletPoint = `• `;
      const indentedText = `${improvement}`;
      doc.text(bulletPoint, 15, newY);
      const improvementLines = doc.splitTextToSize(indentedText, pageWidth - 35);
      doc.text(improvementLines, 20, newY);
      newY += (improvementLines.length * 6) + 4; // Improved spacing
    });
  } else {
    doc.setFontSize(11);
    doc.text("No critical improvement areas identified.", 15, newY);
    newY += 10;
  }
  
  return newY;
};
